<script>
  export default {
    name: 'RichTextLayout',
  };
</script>

<template>
  <div class="product-view__content">
    <header class="product-view__header m-dsk">
      <h1 class="product-view__title">
        <slot name="title" />
      </h1>
    </header>

    <div class="product-view__description">
      <div class="wysiwyg">
        <slot name="content" />
        <!-- Uppercase/Lowercase size -->
        <p>
          <slot name="letterCase" />
        </p>
        <!-- Legend -->
        <div class="js-custom-plate__symbols-legend">
          <h4>Available Symbols:</h4>
          <ul>
            <slot name="legend" />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
